import { StorageState } from '../../../../reducers';
import { createDataFetchSliceSelectors } from '../../../../utils/dataFetch';


export const accountStatisticBalanceSliceSelector = (state: StorageState) => state.accounts.statistic.balance;

export const accountStatisticBalanceSelectors = createDataFetchSliceSelectors(
    accountStatisticBalanceSliceSelector
);
